"use client";

import { useRef } from "react";

export const useUpdateRef = <T>(d: T) => {
  const ref = useRef<T>(d);

  ref.current = d;

  return ref;
};
